"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.333 8H.667C.3 8 0 7.775 0 7.5S.3 7 .667 7h5.666C6.7 7 7 7.225 7 7.5s-.3.5-.667.5zM6.25 6h-4.5C1.337 6 1 5.775 1 5.5s.337-.5.75-.5h4.5c.413 0 .75.225.75.5s-.337.5-.75.5zM5.333 4H3.667C3.3 4 3 3.775 3 3.5s.3-.5.667-.5h1.666C5.7 3 6 3.225 6 3.5s-.3.5-.667.5z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.411 9.705c-.394 0-.715-.29-.715-.646 0-.358.32-.647.715-.647.394 0 .715.289.715.646 0 .357-.32.647-.715.647zM9.295 3.56h1.917l.92 1.941H9.294V3.56zM4.082 9.705c-.395 0-.715-.29-.715-.646 0-.358.32-.647.715-.647.394 0 .715.289.715.646 0 .357-.321.647-.715.647zm8.444-6.656c-.225-.476-.742-.784-1.314-.784H9.295v-.971C9.295.58 8.655 0 7.865 0H1.43C.64 0 0 .58 0 1.294v6.47C0 8.48.64 9.06 1.43 9.06h.507c0 1.072.96 1.941 2.145 1.941 1.184 0 2.145-.869 2.145-1.941h3.039c0 1.072.96 1.941 2.145 1.941s2.145-.869 2.145-1.941h.029c.395 0 .715-.29.715-.647V6.794l-1.774-3.745z"
}))), 'FastDelivery', {
  viewBox: '0 0 24 11'
});

exports.default = _default;